/* @flow */

import * as React from 'react';
import omit from 'lodash/omit';
import { TweenLite } from 'gsap';

type Props = {
  afterProps: Object,
  beforeProps: Object,
  children?: any,
  delay: number, // in seconds
};

type State = {};

class ChangePropsOnMount extends React.Component<Props, State> {
  props: Props;
  state: State;

  static defaultProps = {
    children: undefined,
    delay: 0.5,
  };

  constructor(...args: Array<any>) {
    super(...args);
    this.state = Object.assign({}, this.props.beforeProps);
  }

  componentDidMount() {
    this.timer = TweenLite.delayedCall(this.props.delay, () => {
      this.setState(Object.assign({}, this.props.afterProps));
    });
  }

  componentWillUnmount() {
    if (this.timer) this.timer.kill();
  }

  timer: Object;

  render() {
    const {
      children,
    } = this.props;
    const props = omit(this.props, Object.keys(this.props.afterProps));
    const child = React.Children.toArray(children)[0];

    if (child) {
      return (
        React.cloneElement(child, Object.assign({}, this.state, props))
      );
    }

    console.warn('oh no, where\'s my child?');
    return null;
  }
}

export default ChangePropsOnMount;
